import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar32Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar32 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar32Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar32">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M223.23 161.223c5.033-13.125 3.329-25.732-3.806-28.153-2.852-.971-5.313-1.099-7.479-.573.016-1.482.024-2.971 0-4.484-.701-51.28-6.522-83.526-85.119-83.526-43.53 0-41.564 45.936-41.564 97.224 0 16.932-1.728 17.234.454 31.538 8.259 30.223 16.557 55.381 34.349 63.823 3.377 13.929 8.434 35.408 8.928 41.086.414 4.763-4.564 14.447-9.08 22.14a152.231 152.231 0 0 0 31.928 3.377c2.103 0 4.189-.056 6.268-.136l66.85-63.082-21.551-59.436c6.849.247 15.291-7.964 19.83-19.782l-.008-.016Z"
            fill={c.skin}
          />
          <G id="Group_2" opacity={0.75}>
            <Path
              id="Vector"
              d="M187.767 223.867c3.775-6.116 10.52-25.421 16.135-42.559l-.064-.167c-13.945 37.645-42.647 59.132-69.199 59.132-5.248 0-9.923-1.051-14.12-3.01 2.7 11.126 6.467 27.069 8.123 35.917 5.4-.079 10.999-.629 16.303-1.991 20.531-5.256 35.559-35.559 42.814-47.322h.008Z"
              fill="#2E2017"
            />
          </G>
          <Path
            id="Vector_2"
            d="M179.549 127.2s-7.956-2.97-21.495-2.867c-7.526.056-16.876 4.914-20.213 5.376-5.256.717-5.304-9.047-5.304-9.047-.255-1.513 13.634-6.801 26.377-6.746 11.173.048 13.284 3.672 20.635 13.284Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            opacity={0.75}
            d="m125.051 212.631 16.023-.948c1.091-.064 1.824.446 1.298 1.505-.9 1.824-3.114 4.062-8.585 4.388-5.296.311-8.155-1.497-9.636-3.145-.845-.932-.279-1.737.892-1.808l.008.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_4"
            d="M224.186 197.093v-.024h.016c0 .008 0 .016-.008.024h-.008Z"
            fill="#fff"
            stroke="#000"
            strokeMiterlimit={10}
          />
          <Path
            id="Vector_5"
            opacity={0.75}
            d="M119.3 142.539c.486 3.465-5.232 27.006.821 31.84 1.887 1.506 9.27-1.672 11.412-1.672 12.623-.024 9.429 3.568 7.534 3.807-1.895.239-15.02 2.405-17.449 2.182-2.429-.223-8.593-2.174-7.892-6.371 1.138-6.817.86-38.92 1.569-42.488.159-.797 2.15-.51 4.005 12.71v-.008Z"
            fill="#2E2017"
          />
          <G id="Group_3" fill="#000">
            <Path
              id="Vector_6"
              d="M172.158 136.009c-3.433-3.623-15.657-8.298-30.295 2.7-.582.438-.414 1.569 0 2.166.414.598.908.414 1.513 0 2.246-1.553 4.842-2.652 7.542-3.384v.047c0 3.696 3.185 6.69 7.112 6.69 3.926 0 7.111-2.994 7.111-6.69 0-.286-.024-.565-.055-.836 2.397.366 4.428.988 5.821 1.768.239.136.415.295.63.295.326 0 .653-.215.86-.629.35-.685.247-1.641-.231-2.143l-.008.016Z"
            />
            <Path
              id="Vector_7"
              d="M89.563 145.916c-.358.486-.382 1.37-.056 1.976.2.358.478.541.749.525.183-.016.358-.111.502-.31.963-1.291 3.838-3.481 7.374-4.89a6.261 6.261 0 0 0-.088 1.035c0 3.48 3.003 6.307 6.706 6.307 3.703 0 6.602-2.739 6.698-6.14.661.574 1.29 1.243 1.871 2.047.383.526.932.486 1.243-.08.302-.573.247-1.457-.136-1.983-7.94-10.966-22.25-1.975-24.847 1.521l-.016-.008Z"
            />
          </G>
          <Path
            id="Vector_8"
            d="M117.317 130.992c.136 1.234-1.322 3.082-2.476 3.082-5.376 0-3.815-.398-16.717.732-5.83.51-12.901 4.309-12.901 4.309s-.909-7.184 1.807-10.298c1.673-1.919 7.017-3.687 12.488-4.356 4.579-.565 9.604-.868 12.567.502 4.627 2.134 4.914 3.098 5.232 6.037v-.008Z"
            fill="#000"
          />
          <G id="Group_4" fill="#000">
            <Path
              id="Vector_9"
              d="M131.287 302.281c-.988-.136-1.967-.279-2.947-.43.98.151 1.959.302 2.947.43Z"
            />
            <Path
              id="Vector_10"
              d="M136.758 302.916c.86.088 1.721.167 2.581.239-.86-.072-1.721-.159-2.581-.239Z"
            />
            <Path
              id="Vector_11"
              d="M128.993 278.164c-.231-2.628-1.434-8.641-2.995-15.713L86.37 288.868a150.92 150.92 0 0 0 33.552 11.428c4.515-7.693 9.493-17.377 9.079-22.132h-.008Z"
            />
            <Path
              id="Vector_12"
              d="M157.926 303.537c-.923.04-1.847.064-2.779.088.932-.016 1.856-.056 2.779-.088Z"
            />
            <Path id="Vector_13" d="M124.287 301.166Z" />
            <Path
              id="Vector_14"
              d="m224.951 240.44-66.849 63.083c40.783-1.656 77.425-19.392 103.746-47.051l-36.897-16.032Z"
            />
          </G>
          <Path
            id="Vector_15"
            opacity={0.75}
            d="M108.151 192.235s11.118 1.704 23.518 1.163c13.722-.598 28.853-3.401 28.853-2.151 0 2.382-21.104 9.796-28.391 9.796-9.557 0-24.386-7.805-23.972-8.816l-.008.008Z"
            fill="#2E2017"
          />
          <G id="hair" fill={c.hair}>
            <Path
              id="hair_2"
              d="M128.395 181.592s-3.926-1.147-6.403-.606c-2.477.542-19.464 14.2-19.52 15.896-.063 1.689 9.788 2.597 14.447 1.991 4.659-.605 12.814-7.613 12.814-7.613s15.41 4.531 18.254 4.476c2.843-.064 18.014-3.202 18.189-4.835.184-1.632-.302-3.384-5.981-5.256-5.678-1.871-23.39-6.769-26.114-6.467-2.723.303-5.678 2.422-5.678 2.422l-.008-.008Z"
            />
            <Path
              id="hair_3"
              d="M216.413 132.338c.064-.168 12.106-30.359-2.214-56.473-14.359-26.193-37.86-27.452-47.011-28.559-9.151-1.107-7.414-10.886-19.09-11.356-11.675-.47-16.246 6.307-23.979 6.785-7.733.47-15.777-2.995-26.664.948C86.57 47.625 84.832 59.3 81.997 65.767c-2.843 6.467-7.573 5.837-10.568 10.098-2.994 4.26-1.736 8.044.16 17.043 1.895 8.991 13.69 52.467 13.69 52.467s-2.645-55.629 11.706-60.83c10.123-3.67 15.777 1.737 25.398-1.106 9.62-2.843 5.208-13.252 20.507-14.04 15.307-.79 8.991 10.727 19.249 16.094 8.991 4.7 23.064-1.624 26.408-3.257-1.943 1.083-7.311 4.747-10.632 13.674-4.101 11.046 12.623 22.873 16.566 29.507 2.898 4.866 4.26 16.525 4.778 22.387 4.07-9.669 8.705-16.693 17.154-15.45v-.016Z"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};
